var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowWhite = function SvgIconArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.562 5.087h-1.05a.46.46 0 0 0-.42.473l.079 4.12L2.118.626a.48.48 0 0 0-.63 0l-.734.734a.45.45 0 0 0 0 .63l9.053 9.053-4.146-.053a.46.46 0 0 0-.473.42v1.05c.026.236.21.42.446.446h6.928a.5.5 0 0 0 .446-.446V5.533a.427.427 0 0 0-.446-.446"
  })));
};
export default SvgIconArrowWhite;